import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, BottoneAPI, Trad, Paginatore, InputLimite } from '../components/';
import { CDatiUtente } from '../Dati';

interface ITestAPIState {
    Utente: CDatiUtente;
}

export class TestAPI extends React.Component<Glob.IRouteGlobaleProps, ITestAPIState> {

    public constructor(props: any) {
        super(props);
        this.state = { Utente: new CDatiUtente() };
    }

    private OnClickBottoneAPI(sender: BottoneAPI, dati: Dati.CRisAPI) {
        alert(dati.Errore + " " + dati.ID_Chiave + " " + (dati.ErrTesti.length > 0 ? dati.ErrTesti[0] : ""));
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        alert(errore.message);
    }

    public render() {
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon lt--hide"><i className="la la-gear"></i></span>
                        <h3 className="kt-portlet__head-label">Login</h3>
                    </div>
                </div>
            </div>
            <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-3">
                            <label>Nome</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" name="Nome" id="Nome" value={this.state.Utente.Nome} onChange={(e) => { this.setState({ Utente: { ...this.state.Utente, Nome: e.currentTarget.value } }) }} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <label>Cognome</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" name="Cognome" id="Cognome" value={this.state.Utente.Cognome} onChange={(e) => { this.setState({ Utente: { ...this.state.Utente, Cognome: e.currentTarget.value } }) }} />
                            </div>
                        </div>
                    </div>

                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-3">
                            <label>Login</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" name="Login" id="Login" value={this.state.Utente.Login} onChange={(e) => { this.setState({ Utente: { ...this.state.Utente, Login: e.currentTarget.value } }) }} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <label>Password</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" name="Password" id="Password" value={this.state.Utente.Password} onChange={(e) => { this.setState({ Utente: { ...this.state.Utente, Password: e.currentTarget.value } }) }} />
                            </div>
                        </div>
                    </div>

                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-3">
                            <label>Email</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" name="Email" id="Email" value={this.state.Utente.Email} onChange={(e) => { this.setState({ Utente: { ...this.state.Utente, Email: e.currentTarget.value } }) }} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <label>ID_Anag</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" name="ID_Anag" id="ID_Anag" value={this.state.Utente.ID_Anag} onChange={(e) => { this.setState({ Utente: { ...this.state.Utente, ID_Anag: Number(e.currentTarget.value) } }) }} />
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <BottoneAPI Testo={Trad.Trad("CreaUtente")} URL="/api/utenti/" Metodo="POST" OnClick={(s, d) => this.OnClickBottoneAPI(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} ParamCorpo={this.state.Utente} />
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    </div>           
            </form>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/TestAPI.tsx